import React from 'react'
import { Chrono } from 'react-chrono';
import { experience } from '../data/experience';

export const Experience = () => {

  return (
    <div className='experience'>
      <h2>Experience</h2>

      <section className="timeline">
        <Chrono
          items={experience}
          hideControls={true}
          fontSizes={{
            cardText: '1rem',
            cardTitle: '2rem',
            title: '1rem',
          }}
          theme={{
            primary: 'white',
            secondary: 'white',
            cardBgColor: '#192327',
            cardForeColor: '#FFFFFF',
            titleColor: 'white',
            titleColorActive: 'black',
          }}>
          <div>
            <p>Began my journey in Competitive Programming with the aim to get better and fast. 6 months down the lane, became 3 star (1750+) rated programmer. I acknowledge that there's still alot more to learn and greater results can be achieved in future with focused practice and consistency. Nevertheless, it's always a pleasure to participate and compete in a contest along side my friends.</p>
          </div>
          <div>
            <p>Participated in my first open source event, and it was so great to have been a part of it. Connected with people from all over India, bringing Github Issues and new Feats to implementation and achieving a score of the difficulty felt proud everytime a PR was merged. I stood #9 from over 1500+ registed mentees with contribution to 7+ major projects and 20 merged PRs.</p>
          </div>
          <div>
            <p>After building up the connections through linkedin, I came in contact with an amazing opportunity to explore the real world side development environments in my beginning phase itself. It was majorly a Frontend developer role, wherein I replicated the Wireframes and Layouts to and every bit to perfection. The app was pre-registered by over 15k members which called upon for more responsibilties. Overall I learnt quite a lot from my seniors.</p>
          </div>
          <div>
            <p>The first ever hackathon I won in my career as a Developer. The overnight rush of completing the project was amazing and it never gets new. We built the Insightify project which is a portal for hotel managers wherein they can enter their old customer database and can get the analytics. The presentation in fron of jury webt really well, and this experience boosted my confidence and interest in further such competitions.</p>
          </div>
          <div>
            <p>Witnessed an exciting Grand Finale of the 'HackOn with Amazon 2022' event at Amazon HYD13. HackOn with Amazon 2022 received an overwhelming response with 13.5k+ registrations from 100 premier tech schools, 90+ ideas, 70+ prototypes and top 10 teams at the Grand Finale showcased their innovate ideas and prototypes across three themes of Fraud Detection (Online), Shopping Experience and Customer Trust. A summer internship was extended for the year 2022. </p>
          </div>
          <div>
            <p>I got an opportunity to innovate and present a CCTV integration solution for assisting Chandigarh Police in investigation through a 2 day in-person national event in collaboration with Infosys, Chandigarh DC. I was honoured to receive the Certificate of Appreciation from IGP,IPS and SSP,IPS and interacting with the Chandigarh Police force.</p>
          </div>          
          <div>
            <p>Winners of a 24-hour non-stop on-campus hackathon conducted on the grounds of my graduation universilty. Teamed up as Fast Vibe to build a dynamic document classifier and document discarding tool using OCR technique and Linear Classifier Models for the 12 given classes. The document is sent to admin verification portal for manual inspection in case it doesn't surpass the bare minimum confidence score. I was extended an internship offer later. </p>
          </div>
        </Chrono>
      </section>
    </div>
  )
}
